import React from 'react';
import { string, array } from 'prop-types';

import PostCard from '../PostCard';

import styles from './PostList.scss';
function PostList({ posts, title }) {
  return (
    <div className={styles.root}>
      {title && <h2 className={styles.title}> {title}</h2>}
      <ul className={styles.postList}>
        {posts.map(post => (
          <li className={styles.cardWrapper} key={post.id}>
            <PostCard className={styles.postCard} {...post} />
          </li>
        ))}
      </ul>
    </div>
  );
}
PostList.propTypes = {
  posts: array.isRequired,
  title: string,
};
PostList.defaultProps = {
  title: '',
};

export default PostList;



// WEBPACK FOOTER //
// ./app/components/PostList/PostList.jsx